import {post,get} from '../libs/ajax.js'

export default {
    // 登录
    login: (data, options) => {
        return post('/login', data, options)
    },
    logout: (data, options) => {
        return post('/logout', data, options)
    },
    // 获取极验验证码
    getCaptcha: (data, options) => {
        return get('/geetest/verify', data, options)
    },
    getUserInfo: (data, options) => {
        return get('/user/info', data, options)
    },
    editPassword: (data, options) => {
        return post('/user/edit_password', data, options)
    },
    // 进入成员系统
    getSubUserList: (data, options) => {
        return get('/entry/user_list', data, options)
    },
    // 个人中心
    getUserCenter: (data, options) => {
        return get('/user/center', data, options)
    },
    // 绑定微信
    bindWeiXin: (data, options) => {
        return post('/user/bind', data, options)
    },
    // 解绑微信 - 弃用，合成一个接口
    unbindWeiXin: (data, options) => {
        return post('/user/bind', data, options)
    },
    // 获取页面权限
    getPageAllowAction: (data, options) => {
        return get('/get_page_allow_action', data, options)
    },
    // 登录alive检测
    checkAlive:()=>{
        return get('/check/alive',{})
    },
    // 登录成员系统落日志
    logLoginUser:()=>{
        return get('/login_user',{})
    },
    // auc权限
    getAUC:(data)=>{
        return get('/auc',data)
    },
    // 获取未分配账户信息
    getUndistributedAccount: (data, options) => {
        return post('/get_undistributed_account', data, options)
    },
    // 获取未分配推广信息
    getUndistributedSubItem: (data, options) => {
        return post('/get_undistributed_subitem', data, options)
    },
    // 获取公共配置
    getUserCommonConfig: (data, options) => {
        return post('/user/get_common_config', data, options)
    },
    // 设置用户页面配置 
    setUserPageConfig: (data, options) => {
        return post('/user/set_page_config', data, options)
    },
    // 获取用户页面配置
    getUserPageConfig: (data, options) => {
        return get('/user/get_page_config', data, options)
    },
}
